export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-2xl md:text-3xl font-semibold">Oppp page is not available there</h1>
      </div>
    );
  }